import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';
import { useRenumerationModal } from '../context/RenumerationModalContext';

const SAMPLE_SIZE = 5;

const RenumerationOverlapWarning: FC = () => {
  const { t } = useTranslate();
  const { data } = useRenumerationModal();

  const sample = data.overlaps.slice(0, SAMPLE_SIZE);
  const remaining = data.overlapCount - sample.length;

  return (
    <div className="renumeration-warning">
      <em className="icon ni ni-alert-circle renumeration-warning__icon" />
      <span className="renumeration-warning__text">
        {t('RangeConflicts', { count: data.overlapCount })}{' '}
        {sample.map((c) => (
          <span
            className="renumeration-warning__chip"
            key={`${c.from}-${c.to}`}
          >
            {formatNumber(c.from)}–{formatNumber(c.to)}
          </span>
        ))}
        {remaining > 0 && (
          <span className="renumeration-warning__more">
            {t('PlusMore', { count: remaining })}
          </span>
        )}
      </span>
    </div>
  );
};

export default RenumerationOverlapWarning;
